import { c as _c } from "react/compiler-runtime";
import Backspace from "@mui/icons-material/Backspace";
import FilterList from "@mui/icons-material/FilterList";
import Search from "@mui/icons-material/Search";
import SwapVert from "@mui/icons-material/SwapVert";
import { Box, IconButton, InputAdornment, Menu, MenuItem, Stack, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useI18nContext } from "#/shared/hooks";
import { DebouncedInput } from "#/shared/ui/molecules/DebouncedInput";
import { useProjectBrowserContext } from "./ProjectBrowserContext";
import { ProjectBrowserFilters } from "./ProjectBrowserFilters";
type ProjectBrowserHeaderProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchInputRef?: React.RefObject<HTMLInputElement | null>;
};
type SortOption = {
  value: "title" | "difficulty" | "date" | "category";
  label: string;
  ascLabel: string;
  descLabel: string;
};
export const ProjectBrowserHeader: React.FC<ProjectBrowserHeaderProps> = t0 => {
  const $ = _c(132);
  const {
    searchValue,
    onSearchChange,
    searchInputRef
  } = t0;
  const {
    LL
  } = useI18nContext();
  const {
    sortBy,
    sortOrder,
    setSort,
    selectedDifficulties,
    showOnlyNew
  } = useProjectBrowserContext();
  const [sortMenuAnchor, setSortMenuAnchor] = useState(null);
  const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
  const [filterPopoverOpen, setFilterPopoverOpen] = useState(false);
  let t1;
  if ($[0] !== LL) {
    t1 = LL.SORT_TITLE();
    $[0] = LL;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== LL) {
    t2 = LL.SORT_TITLE_ASC();
    $[2] = LL;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== LL) {
    t3 = LL.SORT_TITLE_DESC();
    $[4] = LL;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      value: "title",
      label: t1,
      ascLabel: t2,
      descLabel: t3
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== LL) {
    t5 = LL.SORT_DIFFICULTY();
    $[10] = LL;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== LL) {
    t6 = LL.SORT_DIFFICULTY_ASC();
    $[12] = LL;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== LL) {
    t7 = LL.SORT_DIFFICULTY_DESC();
    $[14] = LL;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = {
      value: "difficulty",
      label: t5,
      ascLabel: t6,
      descLabel: t7
    };
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== LL) {
    t9 = LL.SORT_DATE();
    $[20] = LL;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== LL) {
    t10 = LL.SORT_DATE_ASC();
    $[22] = LL;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== LL) {
    t11 = LL.SORT_DATE_DESC();
    $[24] = LL;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t9) {
    t12 = {
      value: "date",
      label: t9,
      ascLabel: t10,
      descLabel: t11
    };
    $[26] = t10;
    $[27] = t11;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== LL) {
    t13 = LL.SORT_CATEGORY();
    $[30] = LL;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== LL) {
    t14 = LL.SORT_CATEGORY_ASC();
    $[32] = LL;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== LL) {
    t15 = LL.SORT_CATEGORY_DESC();
    $[34] = LL;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t13 || $[37] !== t14 || $[38] !== t15) {
    t16 = {
      value: "category",
      label: t13,
      ascLabel: t14,
      descLabel: t15
    };
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t12 || $[41] !== t16 || $[42] !== t4 || $[43] !== t8) {
    t17 = [t4, t8, t12, t16];
    $[40] = t12;
    $[41] = t16;
    $[42] = t4;
    $[43] = t8;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  const SORT_OPTIONS = t17;
  const handlePropagation = _temp;
  let t18;
  if ($[45] !== onSearchChange) {
    t18 = value => {
      onSearchChange(value.trim());
    };
    $[45] = onSearchChange;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  const handleChange = t18;
  let t19;
  if ($[47] !== onSearchChange) {
    t19 = ev_0 => {
      handlePropagation(ev_0);
      onSearchChange("");
    };
    $[47] = onSearchChange;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  const handleClear = t19;
  let t20;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = ev_1 => {
      handlePropagation(ev_1);
      setSortMenuAnchor(ev_1.currentTarget);
    };
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  const handleSortMenuOpen = t20;
  let t21;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = () => {
      setSortMenuAnchor(null);
    };
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  const handleSortMenuClose = t21;
  let t22;
  if ($[51] !== setSort) {
    t22 = (option, order) => {
      const orderCapitalized = order.charAt(0).toUpperCase() + order.slice(1);
      const sortValue = `${option.value}${orderCapitalized}`;
      setSort(sortValue);
      handleSortMenuClose();
    };
    $[51] = setSort;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  const handleSortSelect = t22;
  let t23;
  if ($[53] !== filterPopoverOpen) {
    t23 = event => {
      handlePropagation(event);
      if (filterPopoverOpen) {
        setFilterMenuAnchor(null);
        setFilterPopoverOpen(false);
        return;
      }
      setFilterMenuAnchor(event.currentTarget);
      setFilterPopoverOpen(true);
    };
    $[53] = filterPopoverOpen;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  const handleFilterClick = t23;
  let t24;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = () => {
      setFilterMenuAnchor(null);
      setFilterPopoverOpen(false);
    };
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  const handleFilterClose = t24;
  let t25;
  if ($[56] !== SORT_OPTIONS || $[57] !== sortBy) {
    t25 = SORT_OPTIONS.find(opt => opt.value === sortBy);
    $[56] = SORT_OPTIONS;
    $[57] = sortBy;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  const currentSortOption = t25;
  const sortLabel = sortOrder === "asc" ? currentSortOption?.ascLabel : currentSortOption?.descLabel;
  const hasActiveFilters = selectedDifficulties.length > 0 || showOnlyNew;
  let t26;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      p: 2,
      borderBottom: 1,
      borderColor: "divider"
    };
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      alignItems: "center"
    };
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      flex: 1
    };
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== LL) {
    t29 = LL.SEARCH_PROJECTS();
    $[62] = LL;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== LL) {
    t30 = LL.SEARCH_PROJECTS();
    $[64] = LL;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      pointerEvents: "auto"
    };
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      input: {
        startAdornment: <InputAdornment position="start"><Search sx={{
            color: "text.secondary",
            fontSize: 20
          }} /></InputAdornment>
      }
    };
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  let t33;
  if ($[68] !== handleChange || $[69] !== searchInputRef || $[70] !== searchValue || $[71] !== t29 || $[72] !== t30) {
    t33 = <Box sx={t28}><DebouncedInput inputRef={searchInputRef} label={t29} title={t30} name="search-project-browser" size="small" fullWidth={true} value={searchValue} onChange={handleChange} onClick={handlePropagation} onKeyDown={handlePropagation} sx={t31} timeout={200} slotProps={t32} /></Box>;
    $[68] = handleChange;
    $[69] = searchInputRef;
    $[70] = searchValue;
    $[71] = t29;
    $[72] = t30;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = {
      pointerEvents: "auto"
    };
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Backspace fontSize="small" />;
    $[75] = t35;
  } else {
    t35 = $[75];
  }
  let t36;
  if ($[76] !== handleClear) {
    t36 = <IconButton title="Clear search input" size="small" onClick={handleClear} sx={t34} aria-label="Clear search">{t35}</IconButton>;
    $[76] = handleClear;
    $[77] = t36;
  } else {
    t36 = $[77];
  }
  let t37;
  if ($[78] !== t33 || $[79] !== t36) {
    t37 = <Stack direction="row" spacing={1} onClick={handlePropagation} sx={t27}>{t33}{t36}</Stack>;
    $[78] = t33;
    $[79] = t36;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      alignItems: "center",
      justifyContent: "flex-start"
    };
    $[81] = t38;
  } else {
    t38 = $[81];
  }
  let t39;
  if ($[82] !== LL || $[83] !== sortLabel) {
    t39 = sortLabel || LL.SORT_BY();
    $[82] = LL;
    $[83] = sortLabel;
    $[84] = t39;
  } else {
    t39 = $[84];
  }
  let t40;
  if ($[85] !== LL) {
    t40 = LL.SORT_BY();
    $[85] = LL;
    $[86] = t40;
  } else {
    t40 = $[86];
  }
  const t41 = Boolean(sortMenuAnchor);
  let t42;
  let t43;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = {
      border: 1,
      borderColor: "divider",
      borderRadius: 1
    };
    t43 = <SwapVert fontSize="small" />;
    $[87] = t42;
    $[88] = t43;
  } else {
    t42 = $[87];
    t43 = $[88];
  }
  let t44;
  if ($[89] !== t40 || $[90] !== t41) {
    t44 = <IconButton onClick={handleSortMenuOpen} size="small" aria-label={t40} aria-haspopup="true" aria-expanded={t41} sx={t42}>{t43}</IconButton>;
    $[89] = t40;
    $[90] = t41;
    $[91] = t44;
  } else {
    t44 = $[91];
  }
  let t45;
  if ($[92] !== t39 || $[93] !== t44) {
    t45 = <Tooltip title={t39} arrow={true}>{t44}</Tooltip>;
    $[92] = t39;
    $[93] = t44;
    $[94] = t45;
  } else {
    t45 = $[94];
  }
  const t46 = hasActiveFilters ? "primary.main" : "divider";
  const t47 = hasActiveFilters ? "primary.main" : "transparent";
  const t48 = hasActiveFilters ? "primary.contrastText" : "inherit";
  const t49 = hasActiveFilters ? "primary.dark" : "action.hover";
  let t50;
  if ($[95] !== t49) {
    t50 = {
      backgroundColor: t49
    };
    $[95] = t49;
    $[96] = t50;
  } else {
    t50 = $[96];
  }
  let t51;
  if ($[97] !== t46 || $[98] !== t47 || $[99] !== t48 || $[100] !== t50) {
    t51 = {
      border: 1,
      borderColor: t46,
      borderRadius: 1,
      backgroundColor: t47,
      color: t48,
      "&:hover": t50
    };
    $[97] = t46;
    $[98] = t47;
    $[99] = t48;
    $[100] = t50;
    $[101] = t51;
  } else {
    t51 = $[101];
  }
  let t52;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <FilterList fontSize="small" />;
    $[102] = t52;
  } else {
    t52 = $[102];
  }
  let t53;
  if ($[103] !== filterPopoverOpen || $[104] !== handleFilterClick || $[105] !== t51) {
    t53 = <Tooltip title="Advanced filters" arrow={true}><IconButton onClick={handleFilterClick} size="small" aria-label="Advanced filters" aria-haspopup="true" aria-expanded={filterPopoverOpen} sx={t51}>{t52}</IconButton></Tooltip>;
    $[103] = filterPopoverOpen;
    $[104] = handleFilterClick;
    $[105] = t51;
    $[106] = t53;
  } else {
    t53 = $[106];
  }
  let t54;
  if ($[107] !== t45 || $[108] !== t53) {
    t54 = <Stack direction="row" spacing={1} sx={t38}>{t45}{t53}</Stack>;
    $[107] = t45;
    $[108] = t53;
    $[109] = t54;
  } else {
    t54 = $[109];
  }
  let t55;
  if ($[110] !== t37 || $[111] !== t54) {
    t55 = <Stack spacing={1.5}>{t37}{t54}</Stack>;
    $[110] = t37;
    $[111] = t54;
    $[112] = t55;
  } else {
    t55 = $[112];
  }
  const t56 = Boolean(sortMenuAnchor);
  let t57;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = {
      paper: {
        onClick: handlePropagation
      }
    };
    $[113] = t57;
  } else {
    t57 = $[113];
  }
  let t58;
  let t59;
  if ($[114] !== SORT_OPTIONS || $[115] !== handleSortSelect || $[116] !== sortBy || $[117] !== sortOrder) {
    t58 = SORT_OPTIONS.map(option_0 => <MenuItem key={`${option_0.value}-asc`} selected={sortBy === option_0.value && sortOrder === "asc"} onClick={() => handleSortSelect(option_0, "asc")}>{option_0.ascLabel}</MenuItem>);
    t59 = SORT_OPTIONS.map(option_1 => <MenuItem key={`${option_1.value}-desc`} selected={sortBy === option_1.value && sortOrder === "desc"} onClick={() => handleSortSelect(option_1, "desc")}>{option_1.descLabel}</MenuItem>);
    $[114] = SORT_OPTIONS;
    $[115] = handleSortSelect;
    $[116] = sortBy;
    $[117] = sortOrder;
    $[118] = t58;
    $[119] = t59;
  } else {
    t58 = $[118];
    t59 = $[119];
  }
  let t60;
  if ($[120] !== sortMenuAnchor || $[121] !== t56 || $[122] !== t58 || $[123] !== t59) {
    t60 = <Menu anchorEl={sortMenuAnchor} open={t56} onClose={handleSortMenuClose} onClick={handlePropagation} slotProps={t57}>{t58}{t59}</Menu>;
    $[120] = sortMenuAnchor;
    $[121] = t56;
    $[122] = t58;
    $[123] = t59;
    $[124] = t60;
  } else {
    t60 = $[124];
  }
  let t61;
  if ($[125] !== filterMenuAnchor || $[126] !== filterPopoverOpen) {
    t61 = <ProjectBrowserFilters anchorEl={filterMenuAnchor} open={filterPopoverOpen} onClose={handleFilterClose} />;
    $[125] = filterMenuAnchor;
    $[126] = filterPopoverOpen;
    $[127] = t61;
  } else {
    t61 = $[127];
  }
  let t62;
  if ($[128] !== t55 || $[129] !== t60 || $[130] !== t61) {
    t62 = <Box sx={t26}>{t55}{t60}{t61}</Box>;
    $[128] = t55;
    $[129] = t60;
    $[130] = t61;
    $[131] = t62;
  } else {
    t62 = $[131];
  }
  return t62;
};
function _temp(ev) {
  ev.stopPropagation();
}